/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'vs-logs';
const componentName = 'vs-log-list-expanded-content';
const prefix = `${moduleName}.${componentName}`;

export const viewFullLogLabel = `${prefix}.viewFullLogLabel`;

export const ENGLISH = {
    [viewFullLogLabel]: 'View Full Log',
};
